import React, { useRef } from 'react';

import { Input } from 'baseui/input';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import _isFunction from 'lodash/isFunction';
import { EMPTY_STRING } from '../../../../constants';

interface NumberInputProps {
	value?: any;
	onChange: (...event: any[]) => void;
	min?: number;
	onChangeCallback?: (props: any) => void;
	disabled?: boolean;
	mode?: string;
	initialValues?: any;
	name?: string;
	minOriginalValue?: boolean;
}

const NumberInput: React.FC<NumberInputProps> = (props) => {
	const {
		value,
		onChange,
		min,
		onChangeCallback,
		disabled,
		mode,
		initialValues,
		minOriginalValue = false,
		name = EMPTY_STRING
	} = props;
	const quantityInputRef = useRef<HTMLInputElement | null>(null);

	React.useEffect(() => {
		// To prevent scrolling change on input (type=number)
		const ignoreScroll = (e: WheelEvent) => {
			e.preventDefault();
		};
		if (quantityInputRef.current) {
			quantityInputRef.current.addEventListener('wheel', ignoreScroll);
		}
	}, [quantityInputRef]);

	const calculateMin = () => {
		if (mode === 'edit' && minOriginalValue) {
			return _get(initialValues, name);
		}
		return min;
	};

	const handleOnChange = (event: React.FormEvent<HTMLInputElement>) => {
		const inputValue = _get(event, ['target', 'value']);

		let parsedValue;
		if (inputValue === '') {
			// Allow empty string to enable complete deletion
			parsedValue = undefined;
		} else {
			parsedValue = !_isNil(min) ? Math.max(min, parseInt(inputValue, 10)) : parseInt(inputValue, 10);
		}
		onChange(parsedValue);

		if (_isFunction(onChangeCallback)) {
			onChangeCallback(props);
		}
	};

	return (
		<Input
			{...props}
			type='number'
			inputRef={quantityInputRef}
			onChange={handleOnChange}
			disabled={disabled}
			value={value}
			min={calculateMin()}
		/>
	);
};

export default NumberInput;
